// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-00d2d9f9]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n#select-items-container[data-v-00d2d9f9] {\n  display: flex;\n  width: 80%;\n  margin: 15px auto;\n}\n#select-items-container ul li[data-v-00d2d9f9] {\n  cursor: pointer;\n}\n#select-items-container ul li[data-v-00d2d9f9]:hover {\n  text-decoration: underline;\n}", ""]);
// Exports
module.exports = exports;
